// intentionally does not follow redux best practices for grabbing state.
// we will remove redux in the far future, and this will help with the transition
import { useContext } from 'react';
import { ReactReduxContext } from 'react-redux';
export var useDsjState = function useDsjState() {
  var reduxContext = useContext(ReactReduxContext);
  return reduxContext.storeState;
};